import apiClient, {timeouts} from 'shared/services/apiClient';
import {Role, LoginResp, SignUpResp, VerifyTokenResp} from "../types";
import {SuccessResponse} from "shared/types/common";
import {endpoints} from "shared/services/endpoints";

export const authService = {
    testAuth: async () => {
        return apiClient
            .post<VerifyTokenResp>(endpoints.auth.verifyToken, {}, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as VerifyTokenResp)
            .catch((reason) => {
                return {success: false, token_active: false, role: Role.User, user_id: 0, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as VerifyTokenResp;
            }
        );
    },

    checkConnection: async () => {
        return {success: true} as SuccessResponse;
    },

    logIn: async (login: string, password: string) => {
        return apiClient
            .post<LoginResp>(endpoints.auth.login, {login, password}, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as LoginResp)
            .catch((reason) => {
                return {success: false, dfs_token_active: false, token: "", role: Role.User, user_id: 0, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as LoginResp;
            }
        );
    },

    logOut: async () => {
        return apiClient
            .post<SuccessResponse>(endpoints.auth.logout, {}, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as SuccessResponse)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as SuccessResponse;
            }
        );
    },

    signUp: async (dfs_access_token: string) => {
        return apiClient
            .post<SignUpResp>(endpoints.auth.signUp, {dfs_access_token}, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as SignUpResp)
            .catch((reason) => {
                return {success: false, username: undefined, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as SignUpResp;
            }
        );
    },

    refreshToken: async (dfs_access_token: string) => {
        return apiClient
            .post<SuccessResponse>(endpoints.auth.refreshToken, {dfs_access_token}, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as SuccessResponse)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as SuccessResponse;
            }
        );
    },
};
